<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <h2 class="filters">
        <img src="@/assets/icons/allergen.svg" alt="Icon" />
      </h2>
      <h2 class="modalText">
        This item contains one or more allergens from your dietary preferences. Would you still like to add to your
        cart?
      </h2>

      <div class="modalFooter">
        <div class="button-container">
          <button class="clearbutton" @click="handleCancel">
            <p>Cancel</p>
          </button>
          <button class="addToCartButton" @click="handleAddToCart">
            <p>Add to Cart</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    handleCancel() {
      this.closeModal()
    },
    handleAddToCart() {
      this.$emit('addToCart')
    },
  },
}
</script>

<style src="../../../assets/css/Modals/FilterModals/ItemAllergenModal.css" scoped></style>
